
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import WebhookConfiguration from "@/components/settings/WebhookConfiguration";

const WebhookSettings = () => {
  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-bold">Configurações de Webhook</h1>
        <p className="text-gray-500">
          Configure webhooks para automatizar ações quando campanhas forem finalizadas
        </p>
      </header>

      <WebhookConfiguration />
    </div>
  );
};

export default WebhookSettings;
